// extracted by mini-css-extract-plugin
export default {"actions":"bills_actions__3qbD4"};